/**
 * 字符串加*方法
 * @param {String} str 要隐藏的字符串
 * @param {Number} frontLen 要保留的开头位数
 * @param {Number} endLen 要保留的结尾位数
 */
function plusXing (str, frontLen, endLen) {
  const len = str.length - frontLen - endLen
  let xing = ''
  for (var i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
}

/**
 * 隐藏银行卡号方法
 * @param {String} bankCardNum 银行卡号
 */
function hideBankCardNum (bankCardNum = '') {
  const length = bankCardNum.length
  if (length < 8) {
    return plusXing(bankCardNum, 0, 1)
  }
  if (length >= 8 && length < 16) {
    return plusXing(bankCardNum, 2, 2)
  }
  if (length >= 16) {
    return plusXing(bankCardNum, 6, 4)
  }
}

/**
 * 隐藏真实姓名方法
 * @param {String} realName 真实姓名
 */
function hideRealName (realName = '') {
  return realName ? plusXing(realName, 0, realName.length - 1) : ''
}

/**
 * 隐藏电话号码方法
 * @param {String} phone 电话号码
 */
function hidePhoneNum (phone = '') {
  const length = phone.length
  if (length < 11) {
    return plusXing(phone, 1, 2)
  }
  if (length === 11) {
    return plusXing(phone, 3, 4)
  }
  if (length > 11) {
    return plusXing(phone, 6, 2)
  }
}

/**
 * 隐藏身份证号码方法
 * @param {String} idCardNum 身份证号码
 */
function hideIdCardNum (idCardNum = '') {
  if (idCardNum.length > 10) {
    return plusXing(idCardNum, 6, 4)
  } else {
    return plusXing(idCardNum, 3, 3)
  }
}

export {
  hideBankCardNum,
  hideRealName,
  hidePhoneNum,
  hideIdCardNum
}
